"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var UI_1 = require("react-remove-scroll/UI");
var UI_2 = require("react-focus-lock/UI");
exports.AutoFocusInside = UI_2.AutoFocusInside;
exports.MoveFocusInside = UI_2.MoveFocusInside;
exports.InFocusGuard = UI_2.InFocusGuard;
exports.classNames = tslib_1.__assign({}, UI_1.RemoveScroll.classNames);



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es5/reExports.js
// module id = 257
// module chunks = 0